export const PACKAGE_NAME = 'jiraNaturalLanguageToJQL';
export const TEAM_NAME = 'gravity-ai';
export const AI_FEATURE_NAME = 'NL Search in Jira';
